/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const legalRegulatoryEnumsNonComplianceEventOptionEnum = {
    InternalProcessGuidelineNotFollowed: 'InternalProcessGuidelineNotFollowed',
    MissingOrIncorrectDocumentation: 'MissingOrIncorrectDocumentation',
    IncorrectOperationalBehavior: 'IncorrectOperationalBehavior',
    Other: 'Other',
} as const;

export type LegalRegulatoryEnumsNonComplianceEventOptionEnumKey =
    (typeof legalRegulatoryEnumsNonComplianceEventOptionEnum)[keyof typeof legalRegulatoryEnumsNonComplianceEventOptionEnum];

export type LegalRegulatoryEnumsNonComplianceEventOption = LegalRegulatoryEnumsNonComplianceEventOptionEnumKey;
